"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTeam = void 0;
function createTeam(response) {
    const team = {
        id: response.teamId,
        abbreviation: response.teamAbv,
        name: response.name,
        city: response.city,
        fullName: response.fullName,
        primaryColor: response.colors[0],
        secondaryColor: response.colors[1],
        byeWeek: response.byeWeek,
    };
    return team;
}
exports.createTeam = createTeam;
//# sourceMappingURL=teams_request.js.map